export const TITLE_READ = 'Faixa de Juros';
export const TITLE_EDIT = 'Adicionar Faixa de Juros';
export const TOOLTIP = 'Adicionar Faixa de Juros';

